import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { OutputTestCalculationDetailsSchema } from '../schema/OutputTestCalculationSchema';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { OutputDataUrl } from './OutputDataUrl';
import { AlgorithmTestCalculationType } from '../../dataobject';

export const postTestCalculate = (params: AlgorithmTestCalculationType) =>
  apiClient
    .post<void>(expand(OutputDataUrl.TEST_CALCULATIONS, {}), params)
    .then((response) =>
      OutputTestCalculationDetailsSchema.parse(response.data),
    );

export const useMutateTestCalculateDagQuery = createApiMutationHook(
  ['outputTestCalculate'],
  getMutationFn(postTestCalculate),
);
